module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_f_albino.1afd6de4.png";